module.exports = __webpack_public_path__ + "media/images/pear_7-4697e5047bf642b6071185ee7b4c0352.jpg";